import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M2 6.75A2.25 2.25 0 0 1 4.25 4.5h15.5A2.25 2.25 0 0 1 22 6.75v5.588a7 7 0 0 0-1.5-1.393V6.75a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75h5.638c.106.524.272 1.027.49 1.5H4.25A2.25 2.25 0 0 1 2 17.25z" }),
      _createElementVNode("path", { d: "M18.25 9.75H5.75a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5M10.945 12.75a7 7 0 0 1 1.33-1.448.8.8 0 0 0-.275-.052H5.75a.75.75 0 0 0 0 1.5zM20.288 16h-3.25v-3.25a.75.75 0 0 0-1.5 0V16h-3.25a.75.75 0 0 0 0 1.5h3.25v3.25a.75.75 0 0 0 1.5 0V17.5h3.25a.75.75 0 0 0 0-1.5" })
    ], -1)
  ]))]))
}
export default { render: render }